export const validateVariable=fetch=>{return({variable})=>{return fetch("/variables",{method:"POST",body:JSON.stringify(variable)})}};